import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';
import { STORAGE, ACTIONS, APIS } from './_config';
import axios from 'axios'
import { Toaster } from "react-hot-toast";



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);



root.render(
  
  <Provider store={store}>

    <Toaster position="top-center" reverseOrder={false} />
    <App />
  </Provider>
);


reportWebVitals();
